import { FC } from "react";

interface HomeMasterCategoryIconSVGProps {
    className?: string;
    selected?: boolean;
}

const HomeMasterCategoryIconSVG: FC<HomeMasterCategoryIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {props.selected ? (
                <path
                    d="M39.375 55.1246V34.1246C39.375 33.4284 39.0984 32.7607 38.6062 32.2685C38.1139 31.7762 37.4462 31.4996 36.75 31.4996H26.25C25.5538 31.4996 24.8861 31.7762 24.3938 32.2685C23.9016 32.7607 23.625 33.4284 23.625 34.1246V55.1246M7.875 26.2496C7.87482 25.4859 8.04125 24.7314 8.36269 24.0386C8.68413 23.3459 9.15284 22.7316 9.73613 22.2386L28.1111 6.49124C29.0587 5.69037 30.2593 5.25098 31.5 5.25098C32.7407 5.25098 33.9413 5.69037 34.8889 6.49124L53.2639 22.2386C53.8472 22.7316 54.3159 23.3459 54.6373 24.0386C54.9588 24.7314 55.1252 25.4859 55.125 26.2496V49.8746C55.125 51.267 54.5719 52.6024 53.5873 53.5869C52.6027 54.5715 51.2674 55.1246 49.875 55.1246H13.125C11.7326 55.1246 10.3973 54.5715 9.41269 53.5869C8.42812 52.6024 7.875 51.267 7.875 49.8746V26.2496Z"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ) : (
                <>
                    <path
                        d="M39.375 55.1246V34.1246C39.375 33.4284 39.0984 32.7607 38.6062 32.2685C38.1139 31.7762 37.4462 31.4996 36.75 31.4996H26.25C25.5538 31.4996 24.8861 31.7762 24.3938 32.2685C23.9016 32.7607 23.625 33.4284 23.625 34.1246V55.1246M7.875 26.2496C7.87482 25.4859 8.04125 24.7314 8.36269 24.0386C8.68413 23.3459 9.15284 22.7316 9.73613 22.2386L28.1111 6.49124C29.0587 5.69037 30.2593 5.25098 31.5 5.25098C32.7407 5.25098 33.9413 5.69037 34.8889 6.49124L53.2639 22.2386C53.8472 22.7316 54.3159 23.3459 54.6373 24.0386C54.9588 24.7314 55.1252 25.4859 55.125 26.2496V49.8746C55.125 51.267 54.5719 52.6024 53.5873 53.5869C52.6027 54.5715 51.2674 55.1246 49.875 55.1246H13.125C11.7326 55.1246 10.3973 54.5715 9.41269 53.5869C8.42812 52.6024 7.875 51.267 7.875 49.8746V26.2496Z"
                        stroke="url(#paint0_linear_196_10129)"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_196_10129"
                            x1="3"
                            y1="15.4996"
                            x2="67.4653"
                            y2="48.1598"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="#4A4A4F" />
                        </linearGradient>
                    </defs>
                </>
            )}
        </svg>
    );
};

export default HomeMasterCategoryIconSVG;
